import React, { useMemo } from 'react'
import BlacklistForm from './_form'

export default function BlacklistAdd (props) {
  const data = useMemo(() => ({}), [])
  return (
    <BlacklistForm data={data} {...props} />
  )
}